// extracted by mini-css-extract-plugin
module.exports = {"header":"Public_header__1CwMc","ccpanotice":"Public_ccpanotice__J6UJs","content-min":"Public_content-min__2ib0O"};